/**
 * Řádek výsledků nad mřížkou katalogu (proposal 003 §4).
 * Vlevo počet s českým plurálem (kotví mřížku hairlinem), vpravo řazení.
 * Při načítání skeleton bez skoku layoutu, při prázdném výsledku se skryje.
 */

import { ChevronDown } from 'lucide-react';
import type { ProductSort } from '../lib/api';
import { pluralMaterial } from '../lib/format';

const SORT_OPTIONS: { value: ProductSort; label: string }[] = [
  { value: 'newest', label: 'Nejnovější' },
  { value: 'price_asc', label: 'Nejlevnější' },
  { value: 'price_desc', label: 'Nejdražší' },
  { value: 'title', label: 'Podle názvu' },
];

export default function ResultsToolbar({
  count,
  loading,
  query,
  sort,
  onSortChange,
}: {
  count: number | undefined;
  loading: boolean;
  query?: string;
  sort: ProductSort;
  onSortChange: (sort: ProductSort) => void;
}) {
  // Prázdný výsledek řeší mřížka svým stavem, řádek skryjeme.
  if (!loading && (count === undefined || count === 0)) return null;

  return (
    <div className="mb-4 flex items-baseline justify-between gap-3 border-t border-line pt-3">
      <span className="text-sm text-ink-soft">
        {loading || count === undefined ? (
          <span className="inline-block h-3.5 w-[72px] rounded bg-paper2 align-middle motion-safe:animate-pulse" />
        ) : (
          <>
            {query ? `Pro „${query}": ` : ''}
            <span className="font-semibold tabular-nums text-ink">{pluralMaterial(count)}</span>
          </>
        )}
      </span>

      <div className="relative inline-flex items-center gap-1.5">
        <label htmlFor="sort" className="text-sm text-ink-soft">
          Řadit:
        </label>
        <select
          id="sort"
          value={sort}
          onChange={(e) => onSortChange(e.target.value as ProductSort)}
          className="cursor-pointer appearance-none rounded-lg bg-transparent py-1 pl-1 pr-5 text-sm font-semibold text-ink outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-board/50"
        >
          {SORT_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <ChevronDown
          className="pointer-events-none absolute right-0 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-ink-soft"
          strokeWidth={2}
        />
      </div>
    </div>
  );
}
